import { lazy } from 'react';

const LazyRoleManagementView = lazy(() => import('./role-management-view'));
export default LazyRoleManagementView;
